import SectionHeader from "../components/SectionHeader";
import SEO from "../components/SEO";
import { NEWS } from "../lib/content";

export default function NewsPage() {
  return (
    <main data-testid="page-news">
      <SEO
        path="/news"
        image="/brand/og-news.jpg"
        title="News & Updates"
        description="Latest news, milestones, prototype releases and partnership announcements from Logarithmic Technologies."
      />
      <section className="relative pt-24 pb-16 md:pt-32 md:pb-20 border-b border-white/5">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          <SectionHeader
            kicker="/ news · research"
            title={<>Notes from<br />the drive room.</>}
            lead="Short, technical updates. No press-release fluff."
          />
        </div>
      </section>

      <section className="relative py-16 md:py-24">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          <ul className="divide-y divide-white/10 border-y border-white/10">
            {NEWS.map((n, i) => (
              <li
                key={n.title}
                data-testid={`news-item-${i}`}
                className="group grid md:grid-cols-12 gap-4 py-8 md:py-10 items-baseline hover:bg-[#0a0a0a] transition-colors"
              >
                <div className="md:col-span-2 font-mono-tech text-[11px] uppercase tracking-widest text-white/50">
                  {n.date}
                </div>
                <div className="md:col-span-2 font-mono-tech text-[10px] uppercase tracking-widest text-[#FF3B30]">
                  {n.category}
                </div>
                <div className="md:col-span-8">
                  <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight">
                    {n.title}
                  </h3>
                  <p className="mt-2 text-white/70 leading-relaxed max-w-3xl">{n.summary}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </main>
  );
}
